import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "subtitle" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    fill: "none",
    "fill-rule": "evenodd"
  }, [
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "9",
      cy: "9",
      r: "9",
      fill: "#D8EFEC"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      stroke: "#3B4157",
      "stroke-linecap": "square",
      "stroke-width": "1.5",
      d: "M5.5 9.5l2 2 5-5"
    })
  ])
], -1)
const _hoisted_3 = {
  key: 2,
  class: "cancellation-info"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_5 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconInfo = _resolveComponent("IconInfo")!
  const _component_BasicButton = _resolveComponent("BasicButton")!
  const _component_CollapsableBox = _resolveComponent("CollapsableBox")!
  const _component_PriceList = _resolveComponent("PriceList")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["order-details", { 'order-confirmed': _ctx.orderConfirmed }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", null, _toDisplayString(_ctx.salesCampaign.name), 1),
      (!_ctx.orderConfirmed)
        ? (_openBlock(), _createBlock(_component_BasicButton, {
            key: 0,
            class: _normalizeClass(["btn", {
          'not-collapsed': _ctx.extendCollapsableBox,
          'collapsed': !_ctx.extendCollapsableBox,
        }]),
            type: "button",
            variant: "none",
            onButtonClicked: _cache[0] || (_cache[0] = ($event: any) => (_ctx.extendCollapsableBox = !_ctx.extendCollapsableBox))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IconInfo)
            ]),
            _: 1
          }, 8, ["class"]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.orderConfirmed)
      ? (_openBlock(), _createBlock(_component_CollapsableBox, {
          key: 0,
          open: _ctx.extendCollapsableBox,
          id: "order-collapse"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.salesCampaign.infoPoints, (infoPoint, index) => {
                  return (_openBlock(), _createElementBlock("li", { key: index }, [
                    _hoisted_2,
                    _createElementVNode("span", null, _toDisplayString(infoPoint), 1)
                  ]))
                }), 128))
              ])
            ])
          ]),
          _: 1
        }, 8, ["open"]))
      : _createCommentVNode("", true),
    (_ctx.showPriceList || _ctx.showOrderBonusCart)
      ? (_openBlock(), _createBlock(_component_PriceList, {
          key: 1,
          "sales-campaign": _ctx.salesCampaign,
          "bonus-cart": _ctx.orderBonusCart,
          "display-order-bonus-cart": _ctx.showOrderBonusCart,
          "show-total": _ctx.showTotal
        }, null, 8, ["sales-campaign", "bonus-cart", "display-order-bonus-cart", "show-total"]))
      : _createCommentVNode("", true),
    (!_ctx.orderConfirmed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("span", {
            innerHTML: _ctx.salesCampaign.cancellationInfo
          }, null, 8, _hoisted_5)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}